import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import Button from "@elements/button";
import LeftArrow from "@svg/LeftArrow";
import { useRiddlesNavigation, useRiddlesOverview } from "../RamadanRiddlesContext";

const RamadanRiddlesGuide: React.FC = () => {
    const t = useTranslations();
    const { setView } = useRiddlesNavigation();
    const { data: overviewData } = useRiddlesOverview();
    const howItWorks = overviewData?.how_it_works;
    const steps =
        howItWorks && howItWorks.length > 0
            ? howItWorks
            : [
                  t("Answer one question every day."),
                  t("Unlock rewards."),
                  t("Miss a day and it's gone."),
                  t("Complete all days for an Eid surprise."),
              ];

    return (
        <div className="relative flex flex-col h-full bg-[#F6EAD5]">
            <div className="w-full">
                <Image
                    src="/svgs/ramadan-riddle-brown-header.svg"
                    alt=""
                    aria-hidden="true"
                    width={495}
                    height={360}
                    sizes="100vw"
                    className="w-full h-auto"
                />
            </div>
            <div className="px-6 pt-6">
                <button
                    type="button"
                    onClick={() => setView("progress")}
                    className="text-white absolute top-6 left-6"
                    aria-label={t("Back")}
                >
                    <LeftArrow />
                </button>
            </div>
            <div className="relative z-10 flex flex-col h-full">
                <div className="flex-1  px-6 pb-[320px] mb-16">
                    <div className="max-w-[400px] mx-auto text-start">
                        <h2 className="text-2xl leading-8 font-extrabold text-[#38190D] uppercase text-start">
                            {t("30 Days of Dabdoob Delights")}
                        </h2>
                        <h3 className="mt-4 text-xl leading-[28px] font-bold text-[#956C4A] uppercase">
                            {t("How it works")}
                        </h3>
                        <ul className="mt-4 space-y-2 text-start">
                            {steps.map((step) => (
                                <li
                                    key={step}
                                    className="flex items-start gap-3 text-base text-black"
                                >
                                    <span className="mt-[6px] h-2.5 w-2.5 rotate-45 bg-[#2F80ED] shrink-0" />
                                    <span className="leading-6">{step}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="absolute bottom-0 left-1/2 w-[82%] max-w-[360px] -translate-x-1/2 -z-10">
                    <Image
                        src="/svgs/ramadan-riddle-how-it-works-mosque.svg"
                        alt=""
                        aria-hidden="true"
                        width={409}
                        height={427}
                        sizes="82vw"
                        className="w-full h-auto"
                    />
                </div>
            </div>

            <div className="sticky inset-x-0 bottom-0 z-20">
                <Image
                    src="/svgs/ramadan-riddle-wave-footer.svg"
                    alt=""
                    aria-hidden="true"
                    width={495}
                    height={160}
                    sizes="100vw"
                    className="w-full h-auto absolute -bottom-2"
                />
                <div className="absolute bottom-6 left-1/2 w-full max-w-[343px] -translate-x-1/2 px-6">
                    <Button
                        theme="light"
                        className="h-10 w-full rounded-full !bg-[#F27D23] !text-white !border-[#F27D23] font-extrabold"
                        onClick={() => setView("progress")}
                    >
                        {t("Start playing")}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default RamadanRiddlesGuide;
